import React from 'react';
import { useParams } from 'react-router-dom';

import '../../assets/css/loggedin.css';

import Container from '@material-ui/core/Container';

export default function ImagenExpositor() {

    const params = useParams();
  
    return (
    <div style={{'marginTop':'70px'}}>
        
        <Container maxWidth="sm" style={{'textAlign':'center'}}>
            <img width="100%" alt="Plano" src={ "https://cafira.sfo2.digitaloceanspaces.com/uploads-administradores/2021-09/" + params.ruta } />
        </Container>
        
    </div>
    );
}